import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConnectBackendService } from 'src/app/service/connect-backend.service';
import { DialogProductSale } from './dialog-product-sale/dialog-product-sale.model';

@Injectable()
export class DialogService {
  private url = environment.api_url;
  constructor(private http: HttpClient, private service: ConnectBackendService) { }


  findSuppiler(body): Observable<any> {
    return this.http.post(`${this.url}/settings/supplier-find`, body, this.service.getHeadersAut());
  }

  productSale(body): Observable<DialogProductSale[]> {
    return this.http.post<DialogProductSale[]>(`${this.url}/bill/product-sale/info`, body, this.service.getHeadersAut())
  }
}
